module.exports = __webpack_public_path__ + "img/arrow2.02ac8e28.svg";